//basic
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import {toJS} from 'mobx';

//api

//custom components
import Test1 from './test1/Test1';
import Test2 from './test2/Test2';
import Test3 from './test3/Test3';

//material-ui

//other libraries

@inject('internal')
@inject('translate')
@observer
export default class Test extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    componentDidMount() {
        this.props.internal.setRoute( this.props.history, this.props.location.pathname);
        this.props.internal.setSubheaderTitle("testik")
        let tab1 = {
            slug: "test-1",
            title: "Testik"
        }
        let tab2 = {
            slug: "test-2",
            title: "Testik2"
        }
        let tab3 = {
            slug: "test-3",
            title: "Testik3"
        }
        this.props.internal.setSubheaderTabs([tab1, tab2, tab3])
    }

    render () {
        const routerData = {
            history: this.props.history,
            location: this.props.location,
            match: this.props.match
        }
        return (
        <div>
            {toJS(this.props.internal.activeTab) === 0 && <Test1 routerData={routerData}/>}
            {toJS(this.props.internal.activeTab) === 1 && <Test2 routerData={routerData}/>}
            {toJS(this.props.internal.activeTab) === 2 && <Test3 routerData={routerData}/>}
        </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/screens/test/Test.jsx